<template>
  <div>
    <div id="flow-chart-one" class="flow-chart-one" width="1100" height="1400"></div>
    <input type="file" ref="upload" style="display: none;">
  </div>

</template>
<script>
import { dia, shapes, highlighters, linkTools } from '@joint/core';
const unit = 4;
const bevel = 1 * unit;
const spacing = 2 * unit;
const fillColor = '#404040';
const fontAttributes = {
  fontFamily: "PPFraktionSans, sans-serif",
  fontStyle: "normal",
  fontSize: 14,
  lineHeight: 18
};
export default {
  name: 'FlowChartOne',
  data() {
    return {
      paper: null,
      graph: null,
      graphBBox: null,
    };
  },
  async mounted() {
    this.init()
    const container = document.querySelector('.right-content');
    const draggable = document.querySelector('#flow-chart-one');

    draggable.ontouchstart = function (ev) {
      const { clientX, clientY } = ev.touches[0]

      const x = clientX - draggable.offsetLeft + container.scrollLeft;
      const y = clientY - draggable.offsetTop + container.scrollTop;

      draggable.ontouchmove = function (ev) {
        draggable.style.left = ev.touches[0].clientX - x + 'px';
        draggable.style.top = ev.touches[0].clientY - y + 'px';

        ev.preventDefault();
      }

      draggable.ontouchend = function (ev) {
        draggable.ontouchmove = null;
        draggable.ontouchend = null;
      }

      return false;
    }
  },
  methods: {
    init() {
      const paperContainer = document.getElementById("flow-chart-one");
      this.graph = new dia.Graph({}, { cellNamespace: shapes });

      this.paper = new dia.Paper({
        model: this.graph,
        cellViewNamespace: shapes,
        width: "1100px",
        height: "1400px",
        async: true,
        sorting: dia.Paper.sorting.APPROX,
        background: { color: "transparent" },
        snapLabels: true,
        clickThreshold: 10,
        interactive: false,
        gridSize: 5,
        defaultConnectionPoint: {
          name: "boundary",
          args: {
            offset: spacing,
            extrapolate: true
          }
        },
        defaultRouter: { name: "rightAngle", args: { margin: unit * 7 } },
        defaultConnector: {
          name: "straight",
          args: { cornerType: "line", cornerPreserveAspectRatio: true }
        } // bevelled path
      });

      paperContainer.appendChild(this.paper.el);
      this.generChart();
      this.graphBBox = this.graph.getBBox();
      this.eventHandle()
    },
    generChart() {
      const title1 = new (this.createText({ x: 240, y: 30, text: '伦理流程说明' }));
      const title2 = new (this.createText({ x: 780, y: 30, text: '审查材料清单' }));

      const step1 = this.createStep({ x: 150, y: 60, w: 180, h: 60, text: "研究者医院伦理\n系统登记备案" });
      const step2 = this.createStep({ x: 150, y: 180, w: 180, h: 60, text: "伦理办公室形式审查" });

      const step3a = this.createStep({ x: 40, y: 400, w: 180, h: 220, text: "简易审查\n\n审查结果为同意的，伦理办整理意见送主任委员审签后传达审查结果，5日内完成；审查结果为修改的，研究者提交伦理复审，不超过10日完成结果传达" });
      const step3b = this.createStep({ x: 260, y: 400, w: 180, h: 220, text: "会议审查\n\n按伦理审查程序2，及时反馈研究者评审意见，提交最近的伦理审查会议，会议审查前，伦理办公室秘书/管理人员以电话/短信等方式通知研究者会议时间和地点，最长不超过15日完成结果传达" });

      const step4 = this.createStep({ x: 150, y: 720, w: 180, h: 60, text: "获得伦理批准启动实施" });
      const line = new (this.createVerticalLine({ x1: 0, y1: 0, x2: 0, y2: 850 }))({
        position: { x: 500, y: 20 },
      });
      const step5 = this.createStep({ x: 580, y: 60, w: 450, h: 90, text: "01 初始审核申请表\n系统下载填写，项目负责人和科室负责人签名后\n上传系统（扫描清晰件上传，尽量避免使用照片）" });
      //const step6 = this.createStep({ x: 580, y: 170, w: 400, h: 90, text: "02 干预性临床研究方案\n系统下载填写，项目负责人和科室负责人签名后上传系统（扫描清晰件上传，尽量避免使用照片）" });
      const step7 = this.createStep({ x: 580, y: 170, w: 450, h: 90, text: "02 非干预性临床研究方案\n系统下载填写，项目负责人和科室负责人\n签名后上传系统（扫描清晰件上传，尽量避免使用照片）" });
      const step8 = this.createStep({ x: 580, y: 280, w: 450, h: 90, text: "03 受试者知情同意书\n若满足免除知情同意书条件（利用既往的病历和/或样本等）的，请填写“免除知情同意申请表”" });
      const step9 = this.createStep({ x: 580, y: 390, w: 450, h: 90, text: "04 项目负责人专业履历" });
      const step10 = this.createStep({ x: 580, y: 500, w: 450, h: 90, text: "05 资金来源证明\n系统下载填写，项目负责人和科室负责人签名后\n上传系统（扫描清晰件上传，尽量避免使用照片）" });
      //const step11 = this.createStep({ x: 580, y: 610, w: 450, h: 90, text: "06 非干预性临床研究方案\n系统下载填写，项目负责人和科室负责人签名后上传系统（扫描清晰件上传，尽量避免使用照片）" });
      const step12 = this.createStep({ x: 880, y: 610, w: 100, h: 40, text: "下载模板" });
      //const step13 = this.createStep({ x: 880, y: 820, w: 100, h: 40, text: "上传文件" });

      this.graph.addCells([
        title1,
        title2,
        step1,
        step2,
        step3a,
        step3b,
        step4,
        line,
        step5,
        //step6,
        step7,
        step8,
        step9,
        step10,
        //step11,
        step12,
        //step13,
        this.createFlow(step1, step2, "bottom", "top"),
        this.createFlow(step2, step3a, "bottom", "top"),
        this.createFlow(step2, step3b, "bottom", "top").labels([
          {
            attrs: { labelText: { text: "<=2天" } },
            position: {
              offset: {
                x: -55,
              }
            }
          }
        ]),

        this.createFlow(step3a, step4, "bottom", "top"),
        this.createFlow(step3b, step4, "bottom", "top").labels([
          {
            attrs: { labelText: { text: "<=15天" } },
            position: {
              offset: {
                x: -55,
              }
            }
          }
        ]),
      ]);

      this.paper.on('element:pointerclick', (elementView, evt) => {
        const { id } = elementView.model;
        if (id === step12.id) {
          const a = document.createElement('a');
          a.href = '/伦理审查材料模板.zip'
          a.download = '伦理审查材料模板.zip';
          a.click();
          setTimeout(() => {
            this.$message.success('模板下载完成')
          }, 1500)
        }
      });
    },
    transformToFitContent() {
      this.paper.transformToFitContent({
        padding: 30,
        contentArea: this.graphBBox,
        verticalAlign: "middle",
        horizontalAlign: "middle"
      });
    },
    eventHandle() {
      const { mask: MaskHighlighter, stroke: StrokeHighlighter } = highlighters;
      this.paper.on("cell:mouseenter", (cellView) => {
        let selector, padding;
        if (cellView.model.isLink()) {
          if (StrokeHighlighter.get(cellView, "selection")) return;
          // In case of a link, the frame is added around the label.
          selector = { label: 0, selector: "labelBody" };
          padding = unit / 2;
        } else {
          selector = "body";
          padding = unit;
        }
        const frame = MaskHighlighter.add(cellView, selector, "frame", {
          padding,
          layer: dia.Paper.Layers.FRONT,
          attrs: {
            "stroke-width": 1.5,
            "stroke-linejoin": "round"
          }
        });
        frame.el.classList.add("jj-frame");
      });

      this.paper.on("cell:mouseleave", () => {
        MaskHighlighter.removeAll(this.paper, "frame");
      });

      this.paper.on("link:pointerclick", (cellView) => {
        this.paper.removeTools();
        dia.HighlighterView.removeAll(this.paper);
        const snapAnchor = function (coords, endView) {
          const bbox = endView.model.getBBox();
          // Find the closest point on the bbox border.
          const point = bbox.pointNearestToPoint(coords);
          const center = bbox.center();
          // Snap the point to the center of the bbox if it's close enough.
          const snapRadius = 10;
          if (Math.abs(point.x - center.x) < snapRadius) {
            point.x = center.x;
          }
          if (Math.abs(point.y - center.y) < snapRadius) {
            point.y = center.y;
          }
          return point;
        };
        const toolsView = new dia.ToolsView({
          tools: [
            new linkTools.TargetAnchor({
              snap: snapAnchor,
              resetAnchor: cellView.model.prop(["target", "anchor"])
            }),
            new linkTools.SourceAnchor({
              snap: snapAnchor,
              resetAnchor: cellView.model.prop(["source", "anchor"])
            })
          ]
        });
        toolsView.el.classList.add("jj-flow-tools");
        cellView.addTools(toolsView);
        // Add copy of the link <path> element behind the link.
        // The selection link frame should be behind all elements and links.
        const strokeHighlighter = StrokeHighlighter.add(
          cellView,
          "root",
          "selection",
          {
            layer: dia.Paper.Layers.BACK
          }
        );
        strokeHighlighter.el.classList.add("jj-flow-selection");
      });

      this.paper.on("blank:pointerdown", () => {
        this.paper.removeTools();
        dia.HighlighterView.removeAll(this.paper);
      });
    },
    createText({ x, y, text }) {
      return dia.Element.define('custom.TextElement', {
        attrs: {
          text: {
            text, // 这里是你要显示的文字
            fill: 'white',            // 文字颜色
            'font-size': 20,          // 文字大小
            'font-weight': 'bold',          // 文字大小
            'text-anchor': 'middle',  // 文字对齐方式
            'ref-x': x,             // x 方向的相对位置
            'ref-y': y,             // y 方向的相对位置
            'y-alignment': 'middle'
          }
        }
      }, {
        markup: [{
          tagName: 'text',
          selector: 'text'
        }]
      });
    },
    createVerticalLine({ x1, y1, x2, y2 }) {
      return dia.Element.define('custom.VerticalLine', {
        attrs: {
          line: {
            x1,
            y1,
            x2,
            y2,
            stroke: 'white',
            'stroke-width': 1
          }
        }
      }, {
        markup: [{
          tagName: 'line',
          selector: 'line'
        }]
      });
    },
    createStart(x, y, text) {
      return new shapes.standard.Rectangle({
        position: { x: x + 10, y: y + 5 },
        size: { width: 80, height: 50 },
        z: 1,
        attrs: {
          body: {
            class: "jj-start-body",
            rx: 25,
            ry: 25
          },
          label: {
            class: "jj-start-text",
            ...fontAttributes,
            text
          }
        }
      });
    },
    createStep({ x = 0, y = 0, w = 100, h = 40, text = 'Hi' }) {
      return new shapes.standard.Path({
        position: { x, y },
        size: { width: w, height: h },
        z: 1,
        attrs: {
          body: {
            stroke: 'white',
            strokeWidth: 1,
            fill: fillColor,
            class: "jj-step-body",
            d: `M 0 ${bevel} ${bevel} 0 calc(w-${bevel}) 0 calc(w) ${bevel} calc(w) calc(h-${bevel}) calc(w-${bevel}) calc(h) ${bevel} calc(h) 0 calc(h-${bevel}) Z`
          },
          label: {
            ...fontAttributes,
            class: "jj-step-text",
            fill: 'white',
            text,
            textWrap: {
              width: w - 35,
              height: -spacing
            }
          }
        }
      });
    },
    createStep2({ x = 0, y = 0, w = 100, h = 40 }) {
      return new shapes.standard.Rectangle({
        position: { x, y },
        size: { width: w, height: h },
        attrs: {
          body: {
            fill: '#ffffff',
            stroke: '#000000',
            strokeWidth: 2,
            rx: 5, // 圆角
            ry: 5  // 圆角
          },
          label: {
            text: '', // 设置文本为空，下面使用 `text` 属性来设置带有样式的文本
            textWrap: {
              text: `<tspan font-weight="bold">这是标题</tspan> 这是内容`,
              width: -10, // 内边距
              height: -10
            },
            fontSize: 14,
            fontFamily: 'Arial, sans-serif',
            fill: '#000000',
            textAnchor: 'middle',
            yAlignment: 'middle',
            xAlignment: 'middle',
          }
        }
      });
    },
    createDecision({ x = 0, y = 0, w = 160, h = 80, text = 'Hi' }) {
      return new shapes.standard.Path({
        position: { x: x - 30, y: y - 10 },
        size: { width: w, height: h },
        z: 1,
        attrs: {
          body: {
            strokeWidth: 1,
            stroke: 'white',
            fill: fillColor,
            class: "jj-decision-body",
            d:
              "M 0 calc(0.5 * h) calc(0.5 * w) 0 calc(w) calc(0.5 * h) calc(0.5 * w) calc(h) Z"
          },
          label: {
            ...fontAttributes,
            class: "jj-decision-text",
            fill: 'white',
            text
          }
        }
      });
    },
    createFlow(source,
      target,
      sourceAnchor = "right",
      targetAnchor = "left") {
      return new shapes.standard.Link({
        source: { id: source.id, anchor: { name: sourceAnchor } },
        target: { id: target.id, anchor: { name: targetAnchor } },
        z: 2,
        attrs: {
          line: {
            stroke: 'white',
            class: "jj-flow-line",
            targetMarker: {
              class: "jj-flow-arrowhead",
              d: `M 0 0 L ${2 * unit} ${unit} L ${2 * unit} -${unit} Z`
            }
          },
          outline: {
            class: "jj-flow-outline",
            connection: true
          }
        },
        markup: [
          {
            tagName: "path",
            selector: "wrapper",
            attributes: {
              fill: "none",
              cursor: "pointer",
              stroke: "transparent",
              "stroke-linecap": "round"
            }
          },
          {
            tagName: "path",
            selector: "outline",
            attributes: {
              fill: "none",
              "pointer-events": "none"
            }
          },
          {
            tagName: "path",
            selector: "line",
            attributes: {
              fill: "none",
              "pointer-events": "none"
            }
          }
        ],
        defaultLabel: {
          attrs: {
            labelBody: {
              stroke: 'white',
              fill: fillColor,
              class: "jj-flow-label-body",
              ref: "labelText",
              d: `
                        M calc(x-${spacing}) calc(y-${spacing})
                        m 0 ${bevel} l ${bevel} -${bevel}
                        h calc(w+${2 * (spacing - bevel)}) l ${bevel} ${bevel}
                        v calc(h+${2 * (spacing - bevel)}) l -${bevel} ${bevel}
                        H calc(x-${spacing - bevel}) l -${bevel} -${bevel} Z
                    `
            },
            labelText: {
              ...fontAttributes,
              fill: 'white',
              class: "jj-flow-label-text",
              textAnchor: "middle",
              textVerticalAnchor: "middle",
            }
          },
          markup: [
            {
              tagName: "path",
              selector: "labelBody"
            },
            {
              tagName: "text",
              selector: "labelText"
            }
          ]
        }
      });
    }
  }
};
</script>

<style scoped lang="less">
.flow-chart-one {

  --jj-color1: white;
  --jj-color2: #707070;
  --jj-color3: #bdbdbd;
  --jj-color4: transparent;

  --step-stroke-color: var(--jj-color1);
  --step-fill-color: var(--jj-color2);
  --step-text-color: var(--jj-color1);

  --decision-stroke-color: var(--jj-color1);
  --decision-fill-color: var(--jj-color2);
  --decision-text-color: var(--jj-color1);

  --start-stroke-color: var(--jj-color1);
  --start-fill-color: var(--jj-color2);
  --start-text-color: var(--jj-color1);

  --flow-stroke-color: var(--jj-color1);
  --flow-label-stroke-color: var(--jj-color1);
  --flow-label-fill-color: var(--jj-color2);
  --flow-label-text-color: var(--jj-color1);

  --flow-selection-color: var(--jj-color4);
  --frame-color: var(--jj-color3);
  --background-color: red;

  position: absolute;
  left: 0;
  top: 0;
  width: 1100px;
  height: 1400px;

  .jj-start-body {
    fill: var(--start-fill-color);
    stroke: var(--start-stroke-color);
  }

  .jj-start-text {
    fill: var(--start-text-color);
  }

  .jj-decision-body {
    fill: var(--decision-fill-color);
    stroke: var(--decision-stroke-color);
    stroke-width: 3;
  }

  .jj-decision-text {
    fill: var(--decision-text-color);
  }

  .jj-flow-line {
    stroke: var(--flow-stroke-color);
    stroke-width: 1;
  }

  .jj-flow-outline {
    stroke: var(--background-color);
    stroke-width: calc(calc(var(--flow-spacing) * 2) + 1px);
  }

  .jj-flow-label-body {
    stroke: var(--flow-label-stroke-color);
    fill: var(--flow-label-fill-color);
    stroke-width: calc(var(--flow-spacing));
  }

  .jj-flow-label-text {
    fill: var(--flow-label-text-color);
  }

  .jj-flow-arrowhead {
    stroke: var(--flow-stroke-color);
    fill: var(--flow-stroke-color);
  }

  .jj-frame {
    fill: var(--frame-color);
  }

  .jj-flow-tools circle {
    stroke: var(--frame-color);
    fill: var(--background-color);
    stroke-width: 2;
  }

  .jj-flow-tools rect {
    stroke: var(--frame-color);
  }

  .jj-flow-selection {
    stroke: var(--flow-selection-color);
    stroke-width: 20px;
    stroke-linejoin: round;
    stroke-linecap: round;
    vector-effect: none;
  }

}
</style>

<style>
/* .v-line{
    color: red;
  } */
</style>